import { useTranslation } from 'react-i18next';

export default function SearchBar({ className, onChange, placeholder }) {
  const { t } = useTranslation();

  return (
    <>
      <input
        type='search'
        placeholder={placeholder || t('global.search_treasure')}
        className={`search-input ${className}`}
        onChange={onChange}
      />
    </>
  );
}
